import {Segment} from '../router/router'
import {ROUTE_TYPES} from '../../routes'
import _ from 'lodash'

export default {
    activeItinerary: function() {
        return Segment.new(ROUTE_TYPES.ITINERARY, window.payload.itinerary.guid)
    },

    leg: function(leg) {
        return Segment.new(ROUTE_TYPES.LEG, leg.get('id'))
    },

    uistatus: function(section, subsection) {
        return Segment.new(ROUTE_TYPES.UISTATUS, (section + '~' + subsection).toLowerCase())
    },

    accommodation: function(accommodation) {
        let accId = accommodation.get('accommodation_guid') ? accommodation.get('accommodation_guid') : accommodation.get('id')
        return Segment.new(ROUTE_TYPES.ACCOMMODATION, accId)  
    },

    activity: function(activity) {
        return Segment.new(ROUTE_TYPES.ACTIVITY, activity.get('place_id'))
    }
}
